import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getTrustPilotConfig = async (locationId) => {
  const response = await axiosInstance.get(`${API.BUSINESS_REVIEWS.TRUST_PILOT}${locationId}`);
  return response;
};

export const getGoogleReviewConfig = async (locationId) => {
  const response = await axiosInstance.get(`${API.BUSINESS_REVIEWS.GOOGLE_CONFIG}${locationId}`);
  return response;
};

export const updateTrustPilotConfig = async (locationId, body) => {
  const response = await axiosInstance.patch(
    `${API.BUSINESS_REVIEWS.TRUST_PILOT}${locationId}`,
    body
  );
  return response;
};

export const updateGoogleReviewConfig = async (locationId, body) => {
  const response = await axiosInstance.patch(
    `${API.BUSINESS_REVIEWS.GOOGLE_CONFIG}${locationId}`,
    body
  );
  return response;
};

export const deleteGoogleReviewConfig = async (locationId) => {
  const response = await axiosInstance.delete(`${API.BUSINESS_REVIEWS.DELETE_GOOGLE}${locationId}`);
  return response;
};

export const deleteTrustPilotConfig = async (locationId) => {
  const response = await axiosInstance.delete(
    `${API.BUSINESS_REVIEWS.DELETE_TRUST_PILOT}${locationId}`
  );
  return response;
};
